<template>
    <section 
        class="news-detail-header-section text-center" 
        :style="`background-image: url('/images/services/${service.img}')`">
        <div class="section-overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12">
                    <h1 v-if="language === LANGUAGES.PT_BR" class="text-white">{{ service.labelPtBR }}</h1>
                    <h1 v-else-if="language === LANGUAGES.ES" class="text-white">{{ service.labelEs }}</h1>
                    <h1 v-else class="text-white">{{ service.labelEn }}</h1>
                </div>
            </div>
        </div>
    </section>
    <section class="news-section section-padding">
        <div class="container">
            <div class="row">
                <div class="col-12" >
                    <component :is="service.component" :language="language"></component>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import { useRoute } from 'vue-router'
import { watch, ref, computed } from "vue";
import { servicesContent } from './ServicesDetails/ServicesContent'
import { useI18n } from 'vue-i18n';
import { markRaw } from 'vue';
import { LANGUAGES } from '@/common/constants';

export default({
    setup() {
        const { locale } = useI18n();
        let service = ref({})
        const route = useRoute()

        const initData = () => {
            const serviceParams = route.params.service

            function retornaServiceContent (value){
                if (value.nameParams == serviceParams)
                    return value;
            }
            let resultService = servicesContent.filter(retornaServiceContent)
            service.value = markRaw(resultService[0])
        }
        initData()

        watch(
            () => route.params,
            () => {
                initData()
            }
        )

        const language = computed(() => {
            return locale.value;
        });

        return {
            service,
            language,
            LANGUAGES
        }
    }
})
</script>
